import { useState, useEffect, useCallback } from 'react';
import { useAuth } from './useAuth';
import { hacerSolicitud } from '../helpers/apiClient';


const useProveedores = (url) => {
  const { renovarToken, cerrarSesion } = useAuth();
  const [proveedores, setProveedores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchProveedores = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const data = await hacerSolicitud(
        url,
        { method: 'GET' },
        renovarToken,
        cerrarSesion
      );
      // Asegurar que siempre sea array
      setProveedores(Array.isArray(data) ? data : (data ? [data] : []));
    } catch (err) {
      setError(err.message);
      setProveedores([]);
    } finally {
      setLoading(false);
    }
  }, [renovarToken, cerrarSesion, url]);

  useEffect(() => {
    if (!url) return;
    fetchProveedores();
  }, [fetchProveedores, url]);

  return { proveedores, loading, error, actualizarProveedores: fetchProveedores };
};

export default useProveedores;
